export default __webpack_public_path__ + "static/media/placeholder_avatar.035be9bc.png";